import { FC, useMemo } from 'react';
import styles from './index.module.less';
import { isEqual, isNotEmpty } from '@lhb/func';
import cs from 'classnames';
import IconFont from '@/common/components/IconFont';

/**
 * @Description 小区卡片
 */
const Card:FC<any> = ({
  data = {},
  curDetail,
  setCurDetail
}) => {

  const isActive = useMemo(() => {
    if (!curDetail) return false;
    // 与数据部门确定，会出现名字相同的数据，但是其他字段会不同
    return isEqual(data, curDetail);
  }, [curDetail]);
  return (
    <div className={cs(styles.cardCon, isActive && styles.active)} onClick={() => setCurDetail(data)}>
      { isActive && <div className={styles.activeIcon}>
        <IconFont
          iconHref='iconcheckbox_select'
        />
      </div>}
      <div className={styles.leftCon}>
        <IconFont
          iconHref='icona-bianzubeifen4'
        />
      </div>
      <div className={styles.rightCon}>
        <div className={styles.name}>{data.name}</div>
        <div className={styles.descCon}>
          {isNotEmpty(data?.liveNum)
            ? <div className={styles.descItem}>
              {isNotEmpty(data?.houseHolds) && <div>户数:{data?.houseHolds}</div>}
              {isNotEmpty(data.liveNum) && <div>居住人数:{data.liveNum}</div>}
            </div>
            : <div className={styles.address}>
              {data?.address}
            </div>}
        </div>
      </div>
    </div>
  );
};


export default Card;
